// require('es7-shim');
// require('promise.prototype.finally').shim();

import Vue from 'vue'
import App from '@/App.vue'

import VueLodash from 'vue-lodash'
import isEmpty from 'lodash/isEmpty'
import cloneDeep from 'lodash/cloneDeep'
import concat from 'lodash/concat'
Vue.use(VueLodash, { name: 'custom', lodash: { cloneDeep, isEmpty, concat } })

import routes from '@/proyectos/mate/routes'
import rtr from '@/router'
var router = rtr(routes)

import {InlineSvgPlugin} from 'vue-inline-svg';
Vue.use(InlineSvgPlugin);

import config from '@/config'

import '@/registerServiceWorker'

import Vuex from 'vuex'
Vue.use(Vuex);

import almacenamiento from '@/almacenamiento'
import createPersistedState from 'vuex-persistedstate'
almacenamiento.plugins = [createPersistedState({
    key: 'mate',
})]
var store = new Vuex.Store(almacenamiento);

import '@/styles/index.scss';

import '@/proyectos/mate/style.scss'

import tachyons from '@/proyectos/mate/tachyons'
Vue.prototype.$tachyons = tachyons

import barra from '@/components/general/barra'
Vue.component('barra', barra);

import paginacion from '@/components/general/paginacion'
Vue.component('paginacion', paginacion);

import Swal from 'sweetalert2/dist/sweetalert2.js'
import '@sweetalert2/theme-minimal/minimal.scss';
config.sweetalert2.buttonsStyling = false;
config.sweetalert2.customClass = {
    confirmButton: tachyons.button,
    cancelButton: tachyons.secondaryButton
};
Vue.prototype.$swal = Swal.mixin(config.sweetalert2)
Vue.prototype.$toast = Swal.mixin(config.sweetToast)

Vue.config.productionTip = false

export default new Vue({
    router,
    store,
    render: h => h(App),
}).$mount('#app')
